import type { OrganizationCountryCode } from '@/entities/organization/Organization'

export type ProductProfile = {
    accounting: {
        hasCostCenters: boolean
        hasDimensions: boolean
    }
    organization: {
        canCreate: boolean
        countries: OrganizationCountryCode[]
    }
}

const productProfiles: Record<'campai' | 'wunderpass', ProductProfile> = {
    campai: {
        accounting: {
            hasCostCenters: true,
            hasDimensions: false,
        },
        organization: {
            canCreate: true,
            countries: ['DE', 'AT', 'LU'],
        },
    },
    wunderpass: {
        accounting: {
            hasCostCenters: false,
            hasDimensions: true,
        },
        organization: {
            canCreate: true,
            countries: ['US'],
        },
    },
}

export const getProductProfile = (productKey: string | undefined): ProductProfile => {
    if (productKey !== 'campai' && productKey !== 'wunderpass') {
        throw new Error(`Unknown product key: ${productKey}`)
    }

    return productProfiles[productKey]
}
